import { type Static, Type } from "@sinclair/typebox"
import { SkillAffinitySchema } from "./colors"

export const SkillIdSchema = Type.Union([
  Type.Literal("guard"),
  Type.Literal("swift"),
  Type.Literal("sneak"),
  Type.Literal("armor"),
  Type.Literal("breakthrough"),
  Type.Literal("ranged"),
  Type.Literal("repair"),
  Type.Literal("rally"),
  Type.Literal("jam"),
  Type.Literal("shift"),
  Type.Literal("deploy"),
  Type.Literal("scrap"),
  Type.Literal("recycle"),
  Type.Literal("scout"),
  Type.Literal("broker"),
  Type.Literal("salvage"),
  Type.Literal("generator"),
  Type.Literal("ko"),
  Type.Literal("focus"),
  Type.Literal("coordinated_strike"),
  Type.Literal("recover"),
  Type.Literal("shield"),
  Type.Literal("charge"),
  Type.Literal("spark"),
  Type.Literal("battery"),
])

export type SkillId = Static<typeof SkillIdSchema>

export const SkillModeSchema = Type.Union([
  Type.Literal("default"),
  Type.Literal("non_exhausting"),
  Type.Literal("self_destruct"),
])

export type SkillMode = Static<typeof SkillModeSchema>

export const SkillSelectionSchema = Type.Object({
  skillId: SkillIdSchema,
  mode: Type.Optional(SkillModeSchema),
  payloadLevel: Type.Optional(
    Type.Integer({
      minimum: 1,
    }),
  ),
  allyRequirement: Type.Optional(
    Type.Union([Type.Literal(1), Type.Literal(2)]),
  ),
})

export type SkillSelection = Static<typeof SkillSelectionSchema>

export const SkillDefinitionSchema = Type.Object({
  id: SkillIdSchema,
  affinity: SkillAffinitySchema,
  isColorless: Type.Boolean(),
  isPassive: Type.Boolean(),
  description: Type.String(),
  supportsAllyRequirement: Type.Boolean(),
  baseCostDelta: Type.Number({
    minimum: 0,
    multipleOf: 0.5,
  }),
  nonExhaustSurcharge: Type.Number({
    minimum: 0,
    multipleOf: 0.5,
  }),
  selfDestructSurcharge: Type.Number({
    minimum: -2,
    multipleOf: 0.5,
  }),
  /** True if activating this skill removes the unit from play (e.g. scrap). */
  scrapsUnit: Type.Optional(Type.Boolean()),
})

export type SkillDefinition = Static<typeof SkillDefinitionSchema>
